export const LENS_MAINNET_RPCS = [
  "https://rpc.lens.xyz",
  "https://api.lens.matterhosted.dev",
  "https://lens-mainnet.g.alchemy.com/v2/N_HuqeYE3mr_enxw-BGFI2rOm1U7bhGy"
];

export const LENS_TESTNET_RPCS = [
  "https://rpc.testnet.lens.dev",
  "https://lens-sepolia.g.alchemy.com/v2/N_HuqeYE3mr_enxw-BGFI2rOm1U7bhGy"
];
